<template>
    <vx-table-row>
        <vx-table-row-title>
            <span data-test="phone-number">{{ formatPhoneNumber(props.modelValue.phone_number) }}</span>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Vendor: </template>
            <span data-test="vendor">{{ vendorLabels[props.modelValue.vendor] }}</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="brand">
            <template v-slot:label> Brand: </template>
            <kiosk-tcr-brand-cell
                v-if="props.modelValue.brand_id"
                :brandId="props.modelValue.brand_id"
                :displayName="props.modelValue.brand_display_name"
            ></kiosk-tcr-brand-cell>
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Brand Trust: </template>
            <span data-test="brand-trust">{{
                props.modelValue.brand_id
                    ? verificationLabel(props.modelValue.brand_verified, props.modelValue.brand_vetting_score)
                    : '—'
            }}</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="campaign">
            <template v-slot:label> Campaign: </template>
            <vx-badge
                v-if="props.modelValue.campaign_id"
                color="slate"
                size="xs"
                class="font-mono"
                data-test="campaign-id"
            >
                {{ props.modelValue.campaign_id }}
            </vx-badge>
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="team">
            <template v-slot:label> Team: </template>
            <kiosk-team-cell
                v-if="props.modelValue.team_id !== null"
                :team-id="props.modelValue.team_id"
                :team-name="props.modelValue.team_name ?? ''"
                :team-status="props.modelValue.team_status ?? ''"
                :team-status-reason="props.modelValue.team_status_reason"
            />
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="synced-at">
            <template v-slot:label> Synced: </template>
            <span :key="syncedAtKey" :title="shortDateTime(props.modelValue.synced_at)">
                {{ fromNow(props.modelValue.synced_at) }}
            </span>
        </vx-table-row-item>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { VxBadge, VxTableRow, VxTableRowItem, VxTableRowTitle } from '@voxie/frontend-components';
import { useInterval } from '@vueuse/core';
import { formatPhoneNumber } from '~/components/filters';
import KioskTeamCell from '~/components/kiosk/KioskTeamCell.vue';
import KioskTcrBrandCell from '~/components/kiosk/kiosk-ten-dlc/list/KioskTcrBrandCell.vue';
import { vendorLabels, verificationLabel } from '~/components/kiosk/kiosk-ten-dlc/tenDlcLabels';
import type { TcrPhoneNumber } from '~/services/adminTenDlcClient.types';
import { fromNow, shortDateTime } from '~/utils/date';

const props = defineProps<{
    modelValue: TcrPhoneNumber;
}>();

const syncedAtKey = useInterval(60000);
</script>
